import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { BodyWrapper, Header, Loader, MainWrapper, Menu } from '@components';
import { businessQuery, linklistsQuery, siteQuery } from '@queries';
import { ChevronRightIcon } from '@svgs';

import { TemplateBreadcrumbs } from '../components/TemplateBreadcrumbs/TemplateBreadcrumbs.jsx';
import { TemplateSidebar } from '../components/TemplateSidebar/TemplateSidebar.jsx';

export const TemplateMenus = () => {
  const { t, i18n } = useTranslation();
  const { businessID, siteID } = useParams();

  // get business
  const { data: businessData, isPending: businessIsPending } = useQuery(
    businessQuery(businessID),
  );

  // get site/template
  const { data: siteData, isPending: siteIsPending } = useQuery(
    siteQuery(siteID),
  );

  // get linklists
  const { data: linklistsData, isPending: linklistsIsPending } = useQuery(
    linklistsQuery({
      order_by: 'name',
      site_id: siteID,
    }),
  );

  return (
    <>
      <Header />
      <BodyWrapper>
        <TemplateSidebar
          businessID={businessID}
          businessData={businessData}
          siteID={siteID}
          siteData={siteData}
        />
        <MainWrapper>
          <TemplateBreadcrumbs businessData={businessData} siteData={siteData}>
            <li className="sb-flex">
              <span>{t('Menus')}</span>
            </li>
          </TemplateBreadcrumbs>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Menus')}</h1>
              <div className="sb-button-list-inline">
                <Link
                  to={`/dashboard/projects/${businessID}/templates/${siteID}/menus/new`}
                  className="sb-btn sb-btn-cancel"
                >
                  Add new
                </Link>
              </div>
            </div>
            {linklistsIsPending && (
              <Loader className="sb-loader sb-loader-large" />
            )}
            {!linklistsIsPending && (
              <div className="sb-content-view-row">
                {linklistsData.objects.map((linklist) => {
                  return (
                    <Menu
                      key={linklist.id}
                      linklist={linklist}
                      path={`/dashboard/projects/${businessID}/templates/${siteID}/menus/${linklist.id}`}
                    />
                  );
                })}
              </div>
            )}
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
